import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import cookie from 'cookie'

import { giphyDarkCharcoal, giphyLightCharcoal } from '@/styles/colors'
import { UserProfile } from '@/types/user'

import User from '../../icons/user'
import Arrow from '../../icons/arrow'
import { API_KEY } from '../../constants/api'

const BUTTON_HEIGHT = 36

const Container = styled.div`
  display: flex;
  width: 200px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  position: relative;
`

const Avatar = styled.div`
  display: flex;
  width: ${BUTTON_HEIGHT}px;
  height: ${BUTTON_HEIGHT}px;
  background: ${giphyLightCharcoal};
`

const AvatarImage = styled.img`
  && {
    width: 100%;
  }
`

const LoginUser = styled.div`
  display: flex;
  align-items: center;
  background: ${giphyDarkCharcoal};
  width: 100%;
  height: ${BUTTON_HEIGHT}px;
  justify-content: space-between;
`

const ArrowContainer = styled.span`
  width: 40px;
`

const Text = styled.a`
  width: 100%;
  display: flex;
  justify-content: center;
  text-decoration: none;
  border-bottom: none;
`

const DropdownMenu = styled.div`
  width: 100%;
  position: absolute;
  top: ${BUTTON_HEIGHT}px;
  background: ${giphyDarkCharcoal};
  font-size: 15px;
  border-top: 4px solid black;
`

const MenuItem = styled.a`
  text-decoration: none;
  border-bottom: none;
  height: ${BUTTON_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    border-bottom: 1px solid ${giphyLightCharcoal};
  }

  &:hover {
    background: ${giphyLightCharcoal};
  }
`

const userFetcher = async (accessToken: string, setUser: (profile: UserProfile) => void) => {
  const URL = `https://x.giphy.com/v1/internal/oauth2/token/validate?access_token=${accessToken}&api_key=${API_KEY}`

  const response = await fetch(URL)
  const { data, meta } = await response.json()

  if (meta.status !== 200) {
    return
  }

  setUser(data.profile)
}

const Login = () => {
  const [user, setUser] = useState<UserProfile | null>(null)
  const [showDropdown, setShowDropdown] = useState(false)

  useEffect(() => {
    const userAccessToken = cookie.parse(document.cookie).access_token
    if (userAccessToken) {
      userFetcher(userAccessToken, setUser)
    }
  }, [])

  const onMouseEnter = () => setShowDropdown(true)

  const onMouseLeave = () => setShowDropdown(false)

  return (
    <Container onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Avatar>{user ? <AvatarImage src={user?.avatar_url} /> : <User />}</Avatar>
      <LoginUser>
        {user ? (
          <>
            <Text href="/dashboard">{user?.display_name || user?.username}</Text>
            <ArrowContainer>
              <Arrow rotate={0} />
            </ArrowContainer>
          </>
        ) : (
          <Text href="/dashboard">Log In</Text>
        )}
      </LoginUser>

      {showDropdown && user && (
        <DropdownMenu>
          <MenuItem href="/dashboard">Dashboard</MenuItem>
          <MenuItem href="/logout?next=/">Logout</MenuItem>
        </DropdownMenu>
      )}
    </Container>
  )
}

export default Login
